import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setClientId, getPermissions } from '../redux/reducers/user'
import { Loading } from 'tr-components/Loading'
import { envAlias } from '../config/endpoints'

export class ClientIdParser extends Component {
  componentDidMount() {
    this.setClientId()
    this.props.getPermissions().then((resp) => {
      const clientDetails = resp.payload
      const currentClient = clientDetails.permissions.find(
        (client) => client.legacyClientId === parseInt(this.props.match.params.clientId, 10)
      )
      window.pendo.initialize({
        visitor: {
          id: clientDetails.customId,
          environment: envAlias,
          application: 'configure'
        },
        account: {
          id: currentClient.legacyClientId,
          name: currentClient.clientName
        }
      })
    })
  }

  setClientId() {
    const {
      match: { params },
      clientId,
      setClientId
    } = this.props
    if (params.clientId !== clientId) {
      setClientId(params.clientId)
    }
  }

  render() {
    const { clientId, permissionsReady, children } = this.props
    if (!clientId || !permissionsReady) return <Loading message="Loading..." />
    return children
  }
}

export const mapStateToProps = (state) => {
  return {
    clientId: state.user.clientId,
    permissionsReady: state.user.fetchedPermissions
  }
}

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setClientId,
      getPermissions
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(ClientIdParser)



// WEBPACK FOOTER //
// ./src/containers/ClientIdParser.js